import { createSlice } from "@reduxjs/toolkit";

// 초기 상태
const initialState = {
    id: null,
    name: "",
    roles: [],
};

const myInfoSlice = createSlice({
    name: "myInfo",
    initialState,
    reducers: {
        // setMyInfo 액션: payload에 담긴 회원 정보를 상태에 병합
        setMyInfo: (state, action) => {
            // 예: action.payload = { id: 2, name: "테스트", roles: ["ADMIN"] }
            return { ...state, ...action.payload };
        },
        // clearMyInfo 액션: 상태를 초기 상태로 리셋
        clearMyInfo: () => initialState,
    },
});

export const { setMyInfo, clearMyInfo } = myInfoSlice.actions;
export default myInfoSlice.reducer;
